var render, staticRenderFns
import script from "./ReportsRegister.vue?vue&type=script&lang=js&"
export * from "./ReportsRegister.vue?vue&type=script&lang=js&"
import style0 from "./ReportsRegister.vue?vue&type=style&index=0&id=4a00fe52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00fe52",
  null
  
)

export default component.exports